import React, { useState, useEffect } from 'react';

// Custom Hook for Number Rolling
const useCountAnimation = (end, duration = 2000, start = 0) => {
  const [count, setCount] = useState(start);

  useEffect(() => {
    let startTime = null;
    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;
      const progress = Math.min((currentTime - startTime) / duration, 1);
      
      // Calculate current value based on progress
      const currentCount = Math.floor(progress * (end - start) + start);
      setCount(currentCount);

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };
    requestAnimationFrame(animate);
  }, [end, duration, start]);

  return count;
};

const SummerHero = () => {
  // Stats Animation Logic
  // Est. Year rolls BACKWARDS from 2026 to 2014
  const estYear = useCountAnimation(2014, 2500, 2026);
  const studentsTrained = useCountAnimation(24000, 2000, 0);
  const annualStudents = useCountAnimation(2000, 2000, 0);

  return (
    <section className="summer-hero">
      <div className="container">
        <div className="hero-content-wrapper">
          
          {/* Primary Heading - Highlighted Summer Camp */}
          <h1 className="hero-main-title">
            THE ULTIMATE <span className="text-orange">SUMMER CAMP</span> 2026
          </h1>
          
          {/* Secondary Heading */}
          <h2 className="hero-sub-headline">
            Make This Summer <span className="text-blue-light">Smarter</span>
          </h2>

          <p className="hero-description">
            Tirupati’s most trusted foundation program for Class 1–10. 
            Empowering students with academic excellence and modern skills for 12+ years.
          </p>

          {/* New Dual-Batch Schedule Bar */}
          <div className="hero-schedule-wrapper">
            {/* Batch 1 */}
            <div className="batch-card highlight">
              <div className="batch-header">Batch 01</div>
              <div className="batch-date">24th April</div>
              <div className="batch-sessions">
                <span>Morning Session</span>
                <span>Evening Session</span>
              </div>
            </div>

            {/* Batch 2 */}
            <div className="batch-card">
              <div className="batch-header">Batch 02</div>
              <div className="batch-date">01st May</div>
              <div className="batch-sessions">
                <span>Morning Session</span>
                <span>Evening Session</span>
              </div>
            </div>
          </div>

          {/* Statistics Grid with Rolling Numbers */}
          <div className="hero-stats-grid">
            <div className="stat-card">
              <h3>{estYear}</h3>
              <p>ESTABLISHED IN</p>
            </div>
            
            <div className="stat-card">
              <h3>{studentsTrained.toLocaleString()}+</h3>
              <p>Students Trained</p>
            </div>
            
            <div className="stat-card">
              <h3>{annualStudents.toLocaleString()}+</h3>
              <p>Students Annually</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default SummerHero;